<template>
  <div class="relative w-full bg-neutral-25 rounded-xl border border-neutral-25 overflow-hidden pointer-events-none" style="height: 120px;">
    <!-- Browser Display Preview -->
    <div class="navigation-bar-preview">
      <!-- Mac Actions -->
      <div class="absolute top-3 left-3 flex items-center" style="gap: 3px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
          <circle cx="2" cy="2" r="2" fill="#FF5E57"/>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
          <circle cx="2" cy="2" r="2" fill="#FFB700"/>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
          <circle cx="2" cy="2" r="2" fill="#00CC1A"/>
        </svg>
      </div>
      <!-- Nav Bar -->
      <div class="nav-bar flex items-center gap-1.5 pl-1.5 py-1.5">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M12.6667 8.66667V6.66667C12.6667 5.19391 11.4727 4 10 4C8.52725 4 7.33334 5.19391 7.33334 6.66667V8.66667M6.66668 16H13.3333C14.0697 16 14.6667 15.4031 14.6667 14.6667V10C14.6667 9.2636 14.0697 8.66667 13.3333 8.66667H6.66668C5.9303 8.66667 5.33334 9.2636 5.33334 10V14.6667C5.33334 15.4031 5.9303 16 6.66668 16Z" stroke="#A4ACB9" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="nav-text text-text-normal">
          https://foreplay.co/agencies/your-agency
        </div>
      </div>
    </div>
    <!-- Verified Badge -->
    <VerifiedBadgeIcon :width="42" :height="42" class="verified-badge" />
  </div>
</template>

<script>
import VerifiedBadgeIcon from '../../../globals/Icons/AgencyIcons/VerifiedBadgeIcon.vue'

export default {
  name: 'VerifiedBrandedProfilePreview',
  components: {
    VerifiedBadgeIcon
  }
}
</script>

<style scoped>
.navigation-bar-preview {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 300px;
  height: 80px;
  background-color: white;
  border-top-left-radius: 8px;
  box-shadow: 0 48px 48px -32px rgba(47, 53, 71, 0.08), 0 40px 40px -24px rgba(47, 53, 71, 0.08), 0 24px 24px -12px rgba(47, 53, 71, 0.08), 0 12px 12px -8px rgba(47, 53, 71, 0.08), 0 4px 4px -3px rgba(47, 53, 71, 0.08);
}
.nav-bar {
  position: absolute;
  top: 30px;
  left: 4px;
  height: 32px;
  width: 328px;
  border-radius: 4px;
  background: linear-gradient(90deg, #F6F8FA 0%, #F6F8FA 100%);
}
.nav-text {
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
}
.verified-badge {
  position: absolute;
  right: 74px;
  top: 19px;
  transform: rotate(15deg);
  z-index: 100;
}
</style>